import { render, staticRenderFns } from "./Teen2.vue?vue&type=template&id=7493cb41&scoped=true&"
import script from "./Teen2.vue?vue&type=script&lang=js&"
export * from "./Teen2.vue?vue&type=script&lang=js&"
import style0 from "./Teen2.vue?vue&type=style&index=0&id=7493cb41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7493cb41",
  null
  
)

export default component.exports